/**
 * @module app.config.opacity
 */

class Controller {
  constructor() {
    /**
     * @export
     */
    this.trackOpacityMin = 20;

    /**
     * @export
     */
    this.trackOpacityMax = 100;
  }
}


/**
 * @const {!angular.Component}
 */
const component = {
  bindings: {
    'labelText': '@',
    'onChange': '&',
    'opacity': '<',
  },
  controller: Controller,
  templateUrl: 'js/app/config/opacity/partial.html'
};

export default angular.module('appConfigOpacityComponent', []).component('appConfigOpacity', component);
